export default "__VITE_ASSET__DplDgZtE__"